import { prefixes, prependIntlIds } from "../utils";

export const unprefixedToastMessages = {
  "admin.app_table.fetch.plural.failure": "Failed to fetch tables",

  "admin.app_table.name.fetch.plural.failure": "Failed to fetch table names",

  "admin.datasource.fetch.singular.failure": "Failed to fetch datasource",

  "admin.datasource.save.singular.failure": "Failed to save datasource",

  "admin.datasource.save.singular.success": "Datasource saved",

  "admin.function.import.singular.failure": "Failed to import function",

  "admin.function.save.singular.failure": "Failed to import function",

  "admin.module.fetch.plural.failure": "Failed to fetch modules",

  "admin.module.save.singular.failure": "Failed to save module",

  "admin.role.save.singular.failure": "Failed to save role",

  "admin.template.apply_version.singular.failure":
    "Failed to apply template version",

  "admin.tBuilder.autosettingDataTemplateItemAsStaticSelect":
    "By picking dynamic select/template select, the column's 'relation type' on data  " +
    "model was automatically set to 'static'. If you do not want this, you need to " +
    "change it in data model.",

  "admin.template.copy.singular.failure": "Failed to copy template",

  "admin.template.import.singular.failure": "Failed to import template",

  "admin.template.save.singular.failure": "Failed to save template",

  "admin.user.save.singular.failure": "Failed to save user",

  advanced_search_search_incomplete_datetime_input_value:
    "Could not run search, because some of the dates were only partially filled out",

  copy_text_to_clipboard: "String was copied to clipboard, use ctrl + v",

  "datasource.fetch.plural.failure": "Failed to fetch data sources",
  "datasource.fetch.singular.failure": "Failed to fetch data source",

  "detail.fetch.plural.failure": "Failed to fetch row details",
  "detail.fetch.singular.failure": "Failed to fetch row detail",

  "detail.prefill.singular.failure":
    "Failed to fetch vales to prefill detail form",

  "detail.fetch.unauthorized.singular.failure":
    "Cannot display detail, because you are not authorized to view the detail template. The permission can be assigned by your administrator",

  "detail.save.plural.failure": "Failed to save row details",
  "detail.save.singular.failure": "Failed to save row detail",

  "feedback.bug_report.submit.singular.failure": "Failed to send bug report",
  "feedback.bug_report.submit.singular.success": "Bug report sent",

  "feedback.submit.singular.failure": "Failed to send feedback",
  "feedback.submit.singular.success": "Feedback sent",

  "file.duplicate": "File {fileName} is a duplicate of an already present file",
  "file.rejected.wrong_type":
    "Files ({names}) were rejected, because they are not of allowed types",
  "file.rejected.too_large":
    "Files ({names}) were rejected, because they are too large. Maximum allowed size per file is {kb}KB",
  "file.rejected.too_many":
    "Files ({names}) were rejected, because they exceeded the maximum of {max} files",

  "filter.create_new.singular.failure":
    "En error occurred while creating filter [{name}]",
  "filter.create_new.singular.success": "Filter [{name}] created",

  "filter.delete.singular.failure": "Failed to delete filter [{name}]",
  "filter.delete.singular.success": "Filter [{name}] deleted",

  "filter.edit.singular.failure": "Failed to save filter [{name}]",
  "filter.edit.singular.success": "Filter [{name}] saved",

  "filter.fetch.plural.failure": "Failed to load filters",

  "function.deserializeParams.singular.failure":
    "Failed getting function params",

  "function.run.plural.failure": "Running functions ({count}) failed",
  "function.run.plural.success": "Functions ({count}) run successfully",
  "function.run.singular.failure": "Running function failed",
  "function.run.singular.success": "Function run successful",

  "function.run.singular.warning": "Function don't run successful", // TEST

  "heg_mapping.delete.singular.failure": "Failed to un-map heg user",

  "heg_mapping.submit_username.singular.failure": "Failed to map heg user",

  "item_table.item_template_info.fetch.singular.failure":
    "Failed to fetch the creteria for relevant items",

  "license.invalid_license.singular.failure": "Invalid license",

  "login.get_available_provider.plural.failure":
    "Failed to load available login methods",

  "password.change.singular.failure":
    "Password change has been unsucessful. Please contact the administrator",
  "password.change.singular.success": "Password has been sucessfully changed",

  "password.reset.singular.failure":
    "Failed to reset password for user {login}",
  "password.reset.singular.success":
    "A password reset link was sent to user {login}, email {email}",

  "password.reset.plural.failure": "Mass password reset failed",
  "password.reset.plural.success": "Mass password reset successful",

  "password.reset.no_email":
    "Could not reset password for users [{users}], because they have no assigned email address",

  "record.add.singular.failure": "Failed to insert record",
  "record.add.singular.success": "Record inserted",

  "record.delete.singular.failure": "Failed to delete record",
  "record.delete.singular.success": "Record deleted",

  "record.edit.singular.failure": "Failed to save record",
  "record.edit.singular.success": "Record saved",

  "relation_table.fetch.singular.failure": "Failed to load relation table data",

  "request.transform_response.singular.failure":
    "Failed to interpret server response",

  "settings.fetch.singular.failure": "Failed to load settings",

  "settings.save.singular.failure": "Failed to save settings",
  "settings.save.singular.success": "Settings saved",

  "table.data.fetch.singular.failure": "Failed to load table",

  "table.rpp.fetch.singular.failure": "Failed to load table paging",

  "table.rpp.save.singular.failure": "Failed to save table paging",

  "templateBuilder.fetch.singular.failure": "Failed to load template model",

  "templateBuilder.save.singular.failure": "Failed to save template model",
  "templateBuilder.save.singular.success": "Model saved",

  "templateBuilder.sqlQuery.fetch.singular.failure": "Failed to load SQL query",

  "user_settings.fetch.singular.failure": "Failed to load user settings",

  "user_settings.update.singular.failure": "Failed to save user settings",

  // HWR
  "hwr.loading.singular.failure": "Failed to load data",
  "hwr.table.fetch_and_set.singular.failure": "Failed to fetch table: {name}",
  "hwr.save.singular.failure": "Failed to save data",

  // Reporting Services
  "reportingServices.loading.singular.failure": "Failed to load the report",
  "reportingServices.loading_params.singular.failure":
    "Failed to load report parameters",

  // TemplateTable
  "templateTable.delete.singular.failure": "Record deletion failed.",
  "templateTable.delete.singular.success": "Record has been deleted.",

  // Login
  "login.singular.failure": "Failed to login:",
  "login.login_options.failure": "Error during login options fetching.",
  "login.google_modal.failure": "Error while fetching informations from google",
  "login.microsoft_modal.failure":
    "Error while fetching informations from microsoft",
  "login.google.failure":
    "User with this email doesn`t exist, pleas contanct admin for further steps",
};

export default prependIntlIds(prefixes.toast, unprefixedToastMessages);
